"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledRouterDomLink = exports.StyledLink = exports.Styles = void 0;
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importStar(require("styled-components"));
const LINK_COLOURS = {
    white: {
        default: "var(--ds-color-white)",
        hover: "var(--ds-color-white)",
        hoverBackground: "var(--ds-color-blue-130)",
        active: "var(--ds-color-cloud)",
        focusRing: "var(--ds-color-blue-100)",
    },
    night: {
        default: "var(--ds-color-night)",
        hover: "var(--ds-color-night)",
        hoverBackground: "var(--ds-color-blue-25)",
        active: "var(--ds-color-metal)",
        focusRing: "var(--ds-color-blue-100)",
    },
    blue: {
        default: "var(--ds-color-blue-100)",
        hover: "var(--ds-color-blue-130)",
        hoverBackground: "var(--ds-color-blue-25)",
        active: "var(--ds-color-blue-130)",
        focusRing: "var(--ds-color-blue-100)",
    },
};
const getLinkColours = ($color) => {
    return $color && $color in LINK_COLOURS
        ? LINK_COLOURS[$color]
        : LINK_COLOURS.blue;
};
exports.Styles = (0, styled_components_1.css) `
    font-family: Roboto, sans-serif;
    padding: 0 0.125rem;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: ${({ $color }) => getLinkColours($color).default};
    border-radius: var(--ds-border-radius);

    &:hover {
        text-decoration: none;
        color: ${({ $color }) => getLinkColours($color).hover};
    }

    &:active,
    &:visited {
        color: ${({ $color }) => getLinkColours($color).active};
    }

    &:not([disabled]):not([tabindex="-1"]):focus {
        outline: none;
        box-shadow:
            0 0 0 2px var(--ds-color-white),
            0 0 0 4px ${({ $color }) => getLinkColours($color).focusRing};
    }
`;
exports.StyledLink = styled_components_1.default.a `
    ${exports.Styles}
`;
exports.StyledRouterDomLink = (0, styled_components_1.default)(react_router_dom_1.Link) `
    ${exports.Styles}
`;
//# sourceMappingURL=Link.styles.js.map